"use client";
import React, { useEffect } from "react";
import dynamic from "next/dynamic";
import SimilarJobs from "./components/SimilarJobs/SimilarJobs.mobile";
import Benefits from "./components/Benefits/Benefits.mobile";
import Desc from "./components/Desc/Desc.mobile";
import RemoteDetail from "./components/RemoteDetail/RemoteDetail.mobile";
import Reminder from "./components/Reminder/Reminder.mobile";
// import Company from "./components/Company/Company.mobile";
import Recruiter from "./components/Recruiter/Recruiter.mobile";
import JobHeader from "./components/JobHeader/JobHeader.mobile";
import Location from "./components/Location/Location.mobile";
import Copyright from "components/Footer/components/Mobile/Copyright";
import { useJobTrans } from "./jobTransProvider";

import styles from "./page.mobile.module.scss";
// import { isMobile } from "react-device-detect";
import { trackAdjustEventBySite } from "app/components/adjust";
import Search from "./components/Search/Search.mobile";
const JobClient = dynamic(() => import("./components/JobClient/JobClient.mobile"), {
  ssr: false
});
export const JobTransWrapped = ({ lang, pageData, jobId, sessionid, dictionary, countryKey }) => {
  const { transData } = useJobTrans();

  useEffect(() => {
    const eventTokens = {
      sg: "1h9o3b",
      jp: "n4lq1o",
      ph: "du1p9i",
      com: "eh43gt",
      id: "5v0kkj"
    };
    trackAdjustEventBySite(eventTokens);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {pageData?.job_description?.identity_restrictions?.length ? (
        <p className={styles.identity}>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <rect width='24' height='24' rx='6' fill='#3CEAF6' />
            <path
              d='M11.1429 9.6673C11.1429 10.9125 10.1334 11.922 8.88817 11.922C7.64293 11.922 6.63347 10.9125 6.63347 9.6673C6.63347 8.42206 7.64293 7.4126 8.88817 7.4126H11.1429V9.6673Z'
              fill='black'
            />
            <path
              d='M12.9736 16.5875C13.0396 16.5875 13.0937 16.535 13.0937 16.469C13.0937 14.1463 11.2108 12.2634 8.88817 12.2634C6.56551 12.2634 4.68262 14.1463 4.68262 16.469C4.68262 16.535 4.73679 16.5875 4.80276 16.5875H12.9736Z'
              fill='black'
            />
            <path
              d='M17.3662 8.4751L19.3178 8.4751'
              stroke='black'
              strokeWidth='2.1'
              strokeLinecap='round'
            />
            <path
              d='M17.3662 12.4595L19.3178 12.4595'
              stroke='black'
              strokeWidth='2.1'
              strokeLinecap='round'
            />
          </svg>
          {pageData?.job_description?.identity_description}
        </p>
      ) : null}
      {pageData?.remote_job_detail?.is_prompt ? (
        <div className={styles.openCountryTip}>
          <span className={styles.tipIcon}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='20'
              viewBox='0 0 20 20'
              fill='none'
            >
              <path d='M10.8345 7.50002V11.6667H9.16781V7.50002H10.8345Z' fill='#FF9000' />
              <path d='M9.16699 12.9167H10.8337V14.5834H9.16699V12.9167Z' fill='#FF9000' />
              <path
                d='M8.55322 2.5324C9.19304 1.4127 10.8075 1.4127 11.4474 2.5324L18.5754 15.0065C19.2103 16.1175 18.408 17.5 17.1283 17.5H2.87225C1.59255 17.5 0.790271 16.1175 1.42518 15.0065L8.55322 2.5324ZM10.0003 3.35929L2.87225 15.8334H17.1283L10.0003 3.35929Z'
                fill='#FF9000'
              />
            </svg>
          </span>
          <p>{pageData?.remote_job_detail?.remote_country_warn}</p>
        </div>
      ) : null}
      <div className={styles.pageInner}>
        <div className={styles.shadowBox}>
          <JobHeader
            transData={transData}
            data={{
              ...pageData.job_header,
              ...pageData.remote_job_detail,
              translationTitle: pageData.job_translation.translation_content.job_title
            }}
          />
          <Recruiter data={pageData.recruiter} />
          <RemoteDetail dictionary={dictionary.jobDetail} data={pageData.remote_job_detail} />
          <Desc
            transData={transData}
            countryKey={countryKey}
            data={{
              ...pageData.job_description,
              extraInfo: pageData.japan_info,
              translationSkills: pageData.job_translation.translation_content.job_skills,
              translationDescription:
                pageData.job_translation.translation_content.job_description_html,
              translationRequirements:
                pageData.job_translation.translation_content.job_requirements_html,
              benefits_info: pageData.benefits_info,
              aiTranslate: {
                translateText: pageData.job_translation.ai_translate_text,
                originalText: pageData.job_translation.show_original_text,
                translationText: pageData.job_translation.show_translation_text
              }
            }}
          />
        </div>

        {/* <Company
          jobId={jobId}
          isMobile={isMobile}
          data={{
            ...pageData.company,
            ...pageData.brand_and_product
          }}
        /> */}
        {pageData?.working_location ? (
          <div className={styles.shadowBox}>
            <Location
              data={pageData.working_location}
              dictionary={dictionary?.jobDetail?.location}
              lang={lang}
            />
            {/* <Benefits data={pageData.benefits_info} /> */}
          </div>
        ) : null}

        <Reminder
          dictionary={dictionary?.jobDetail?.reminder}
          jobId={jobId}
          sessionid={sessionid}
        />

        <p className={styles.pubDate}>{pageData.published_at}</p>

        <SimilarJobs
          lang={lang}
          sessionid={sessionid}
          data={{
            ...pageData.similar_job,
            publishedAt: pageData.published_at
          }}
        />
      </div>

      <JobClient data={pageData} sessionid={sessionid} jobId={jobId} />
      <Search jobId={jobId} />
    </>
  );
};
export default JobTransWrapped;
